import React from 'react'
import { createRoot } from 'react-dom/client'
import ProductTile from "./ProductTile.jsx"
import { getProductsByIds } from "../../utils/Product.js"
import { makeid } from '../../utils/helpers'
import { Provider } from 'react-redux'
import store from '../store/store'

const appAttribute = 'product-tile'
const apiAttribute = 'data-plp-item'

document.addEventListener('DOMContentLoaded', () => {
  // const observeRoot = document.querySelector('#MainContent')
  // const config = { childList: true, subtree: true }
  // const observer = new MutationObserver(observerCallback)
  // observer.observe(observeRoot, config)

  const productTiles = document.querySelectorAll(`[${appAttribute}]`)
  productTiles.forEach((tile) => setupProductTile(tile))

  setupApiTiles()
})

// const observerCallback = (mutationList, observer) => {
//   mutationList.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (!(node instanceof HTMLElement)) return
//       if (node.hasAttribute(appAttribute)) setupProductTile(node)
//     })
//   })
// }

const setupApiTiles = (parent=document) => {
  const apiTiles = parent.querySelectorAll(`[${apiAttribute}][data-inited="false"]`)
  apiTiles.forEach(tile => tile.setAttribute('data-inited', 'true'))
  const ids = Array.from(apiTiles).map(tile => `"gid://shopify/Product/${tile.dataset.plpItem}"`)
  getProductsByIds((products) => {
    products.forEach(json => {
      const id = json.id.replace('gid://shopify/Product/', '')
      const wrappers = parent.querySelectorAll(`[${apiAttribute}="${id}"]`)
      wrappers.forEach(wrapper => {
        const randKey = makeid(5)
        const tile = document.createElement('div')
        tile.setAttribute('data-id', `plp-tile-${id}-${randKey}`)
        tile.setAttribute(appAttribute, false)
        tile.setAttribute('props', JSON.stringify(json))
        tile.setAttribute('related', wrapper.getAttribute('related'))
        const div = document.createElement('div')
        div.appendChild(tile)
        wrapper.innerHTML = div.innerHTML
        setTimeout(() => {
          setupProductTile(wrapper.querySelector(`[data-id="plp-tile-${id}-${randKey}"]`))
        }, 100)
      })
    })
    const swatTimer = setInterval(() => {
      if(typeof window._swat != 'undefined' && window._swat && window._swat.initializeActionButtons) {
        clearInterval(swatTimer)
        setTimeout(() => {
          window._swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
        }, 300)
      }
    }, 100)
  }, ids)
}
window.setupApiTiles = setupApiTiles

const setupProductTile = (productTileEl) => {
  if(typeof productTileEl != 'undefined' && productTileEl != null) {
    const propsRaw = productTileEl.getAttribute('props')
    propsRaw.replaceAll("'", "`")
    try {
      const props = JSON.parse(propsRaw)
      // const sectionIdRaw = productTileEl.getAttribute('section_id')
      // const sectionId = JSON.parse(sectionIdRaw) || ''

      const root = createRoot(productTileEl)
      root.render(<Provider store={store}><ProductTile props={props} /></Provider>) 
    } catch (error) {
      console.log('product tile error', error)
      console.log('propsRaw', propsRaw)
    }
  }
}

window.setupATile = setupProductTile

window.setupProductTiles = (tiles) => {
  tiles.forEach((tile) => setupProductTile(tile))
}